/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import ComponentBase from '../Utility/ComponentBase';
import CLog, { LogTypes } from '../Utility/ComponentLogger';
import { ISlotGamePlayResult } from './Object/BaseGamePlayResult';
import IPlayResultComponent from './Object/IPlayResultComponent';
import { IPlayResult } from './Object/PlayResult';
import PlayResultComponent from './PlayResultComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class PlayResultLogger extends ComponentBase
{
    /** Reference to [[PlayResultComponent]] to be injected. */
    @property({ type: InjectableComponent })
    protected playResultComponentRef: InjectableComponent<IPlayResultComponent>
        = new InjectableComponent<IPlayResultComponent>();

    /** @hidden */
    protected setContexts(): void
    {
        this.playResultComponentRef.SetContext(PlayResultComponent);
    }

    /** @hidden */
    protected start(): void
    {
        super.start();

        this.playResultComponentRef.Value.OnResult(() => this.logResult());
    }

    /** Log the result to the local system storage. */
    private logResult(): void
    {
        try
        {
            const playResult: IPlayResult = this.playResultComponentRef.Value.ResultData.PlayResult;
            const slotResult: ISlotGamePlayResult = playResult.BaseGamePlayResult.SlotGamePlayResult;

            if (!slotResult) { return; }

            const logTitle: string = `PLAY_SEQUENCE_${playResult.PlaySequenceNumber} `
                + `| TOTAL: ${playResult.BaseGameAward} | BONUS: ${playResult.BonusGameFlag}`;

            const outcomeLogObject: any =
            {
                ReelFace: slotResult.reelFace,
                SubReelFace: slotResult.substitutedReelFace,
            };

            const outcomeString: string = JSON.stringify(outcomeLogObject);
            cc.sys.localStorage.setItem(logTitle, outcomeString);
            CLog.log(outcomeString, LogTypes.All);
        }
        catch (error)
        {
            CLog.log(JSON.stringify(error), LogTypes.None);
        }
    }
}
